module.exports = __webpack_public_path__ + "img/UNODC-logo-full.c020e432.png";